import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import Typography from '@mui/material/Typography';
import { isValidElement } from 'react';

import { CardSx, SubtitleSx, TitleSx, ValueSx } from './styles';
import { StatsCardProps } from './types';

const StatsCard = (props: StatsCardProps) => {
  const { 'data-testid': dataTestId, title, value, subtitle } = props;

  const renderTitle = () => {
    if (isValidElement(title)) {
      return title;
    }
    return <Typography sx={TitleSx}>{title}</Typography>;
  };

  return (
    <Card sx={CardSx} data-testid={dataTestId}>
      {renderTitle()}
      <Typography sx={ValueSx}>{value}</Typography>
      {subtitle && <Box sx={SubtitleSx}>{subtitle}</Box>}
    </Card>
  );
};

export default StatsCard; 
